import React, { useEffect, useState } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { BLOG_POSTS } from './blogPosts';
import './FurtherReading.css';

// CEL-3040 (Sep 26 2026): the blog build writes /blog/registry.json on every release (deploys AND zero-deploy
// publishes), so titles, excerpts and reading times come live from there. One fetch per page load, shared by every
// FurtherReading on the page; any failure keeps the bundled copy (the prerendered HTML always uses it).
let registryPromise = null;
function loadRegistry() {
  if (!registryPromise) {
    registryPromise = fetch('/blog/registry.json', { credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return registryPromise;
}

/**
 * FurtherReading — list of blog-post links rendered on role + compare pages
 * ("From the blog" section). Internal-link surface: transfers the ranking
 * authority of the money pages into the blog cluster and gives readers a
 * deeper next step (2026-07-30, Nitish-approved).
 *
 * Which posts appear is an editorial choice made in code (the slug lists);
 * what each card SAYS comes from the live registry (CEL-3040).
 *
 * Renders ONLY the list; each template wraps it in its own <Section> so the
 * section chrome matches that surface exactly.
 *
 * Links are plain <a href> anchors ON PURPOSE: the blog is a static nginx
 * surface, not a React route — a client-side <Link> would dead-end in the
 * SPA (same rule as the header/footer Blog links).
 */
export default function FurtherReading({ slugs }) {
  const [live, setLive] = useState(null);
  useEffect(() => {
    let alive = true;
    loadRegistry().then((reg) => {
      if (alive && reg && typeof reg === 'object') setLive(reg);
    });
    return () => {
      alive = false;
    };
  }, []);

  const posts = (slugs || [])
    .map((s) => {
      const fromLive = live && live[s];
      const bundled = BLOG_POSTS[s];
      if (fromLive && fromLive.url && fromLive.title) return { ...bundled, ...fromLive };
      return bundled;
    })
    .filter(Boolean);
  if (!posts.length) return null;
  return (
    <div className="fr-list">
      {posts.map((p) => (
        <a className="fr-row" key={p.url} href={p.url}>
          <span className="fr-row__body">
            <span className="fr-row__t">{p.title}</span>
            <span className="fr-row__x">{p.excerpt}</span>
          </span>
          <span className="fr-row__m">
            {p.readingTime} min <ArrowRightOutlined />
          </span>
        </a>
      ))}
    </div>
  );
}
